"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var mm = _interopRequireWildcard(require("@tunein/music-metadata-browser"));
var _get = _interopRequireDefault(require("lodash/get"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _events = _interopRequireDefault(require("events"));
var _streamEvents = _interopRequireDefault(require("./constants/streamEvents"));
var _playerMethods = _interopRequireDefault(require("./constants/playerMethods"));
var _htmlMediaEvents = _interopRequireDefault(require("./constants/htmlMediaEvents"));
var _PlayerLoader = _interopRequireDefault(require("./PlayerLoader"));
var _Timer = _interopRequireDefault(require("../utils/Timer"));
var _getStartFromPosition = _interopRequireDefault(require("./utils/getStartFromPosition"));
var _errorCodes = _interopRequireDefault(require("../utils/errorCodes"));
var _debugger = _interopRequireDefault(require("../debugger"));
var _hlsEvents = _interopRequireDefault(require("./hlsjs/constants/hlsEvents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-underscore-dangle */
/**
 * The StreamPlayer interface that is responsible for exposing methods
 * that allow the web-tuner to manipulate the underlying media. This
 * class is also responsible for exposing specific tunerChannel emitter
 * methods that allow the rest of the web-tuner to listen and perform
 * actions based on the state events that are emitted from the currently
 * loaded media.
 * @module StreamPlayer
 */
var StreamPlayer = /*#__PURE__*/(0, _createClass2["default"])(function StreamPlayer(config) {
  var _this = this;
  (0, _classCallCheck2["default"])(this, StreamPlayer);
  /**
   * Method to provide player instances with a "hook" that is called synchronously
   * from the user gesture event handler. This becomes necessary on mobile and Safari
   * desktop browsers due to the autoplay restrictions that exist for asynchronous
   * playback within click handlers. Player instances can implement a .preload method that
   * will be called synchronously here before any asynchronous code. This "hook" allows us
   * preload a blank mp3 into the players synchronously, and then asynchronously switch the
   * source with the desired stream url after Tune.ashx API call to retrieve stream urls resolves.
   *
   * See Apple documentation here:
   *  https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/Using_HTML5_Audio_Video/Device-SpecificConsiderations/Device-SpecificConsiderations.html#//apple_ref/doc/uid/TP40009523-CH5-SW4
   *  @function preload
   */
  (0, _defineProperty2["default"])(this, "preload", function () {
    _this.playerLoader.allPlayers.forEach(function (player) {
      if (!player[_playerMethods["default"].preload]) {
        return;
      }
      player[_playerMethods["default"].preload](_this.blankMp3Url);
    });
  });
  /**
   * Try to play the stream
   * @function attemptPlayback
   * @param playbackConfig {{
   *    stream: Object,
   *    playFromPosition: Number,
   *    additionalTimeout: Number,
   *    ignoreStreamPosition: Boolean,
   *    liveSeekStreamPosition: Number
   *    }}
   * @returns {Object<{ duration: Number }>}
   */
  (0, _defineProperty2["default"])(this, "attemptPlayback", /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(playbackConfig) {
      var _playbackConfig$strea, stream, playFromPosition, additionalTimeout, ignoreStreamPosition, liveSeekStreamPosition, instreamTrackingUrl, url, format, position, playbackPosition, options, start;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _playbackConfig$strea = playbackConfig.stream, stream = _playbackConfig$strea === void 0 ? {} : _playbackConfig$strea, playFromPosition = playbackConfig.playFromPosition, additionalTimeout = playbackConfig.additionalTimeout, ignoreStreamPosition = playbackConfig.ignoreStreamPosition, liveSeekStreamPosition = playbackConfig.liveSeekStreamPosition, instreamTrackingUrl = playbackConfig.instreamTrackingUrl;
            url = stream.url, format = stream.format, position = stream.position;
            playbackPosition = (0, _getStartFromPosition["default"])({
              position: position,
              playFromPosition: playFromPosition,
              ignoreStreamPosition: ignoreStreamPosition,
              liveSeekStreamPosition: liveSeekStreamPosition
            });
            options = {
              url: url,
              format: format,
              playbackPosition: playbackPosition,
              additionalTimeout: additionalTimeout,
              instreamTrackingUrl: instreamTrackingUrl
            };
            start = Date.now();
            _context.prev = 5;
            _context.next = 8;
            return _this._attemptStreamPlayback(stream, options);
          case 8:
            return _context.abrupt("return", {
              duration: Date.now() - start
            });
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            _context.t0.errorData = {
              duration: Date.now() - start
            };
            throw _context.t0;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 11]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  /**
   * Given a nowPlaying model, this setTitle method builds a formatted title
   * from the title and subtitle of the nowPlaying model.
   * @function setTitle
   * @param nowPlaying {Object}
   */
  (0, _defineProperty2["default"])(this, "setTitle", function (nowPlaying) {
    var title = nowPlaying ? "".concat(nowPlaying.title, " - ").concat(nowPlaying.subtitle) : null;
    _this._invokePlayerMethod(_playerMethods["default"].setTitle, title);
  });
  /**
   * Play the stream
   * @event module:StreamPlayer~play
   * @returns {Promise}
   */
  (0, _defineProperty2["default"])(this, "play", function () {
    return _this._monitorForStreamTimeout(_this._invokePlayerMethod(_playerMethods["default"].play));
  });
  /**
   * @event module:StreamPlayer~pause
   */
  (0, _defineProperty2["default"])(this, "pause", function () {
    _this._invokePlayerMethod(_playerMethods["default"].pause);
  });
  /**
   * @event module:StreamPlayer~stop
   */
  (0, _defineProperty2["default"])(this, "stop", function () {
    _this._invokePlayerMethod(_playerMethods["default"].stop);
  });
  (0, _defineProperty2["default"])(this, "canChangePlaybackRate", function () {
    return _this._invokePlayerMethod(_playerMethods["default"].canChangePlaybackRate);
  });
  (0, _defineProperty2["default"])(this, "changePlaybackRate", function () {
    var rate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;
    var currentPlaybackRate = _this._invokePlayerMethod(_playerMethods["default"].getPlaybackRate);
    if (rate === currentPlaybackRate) {
      return;
    }
    _this.pause();
    _this._invokePlayerMethod(_playerMethods["default"].changePlaybackRate, rate);
    _this.play();
  });
  /**
   * Method responsible for calling setVolume on the chosen media player. Each media
   * player implementation is responsible for formatting the volume depending on the
   * requirements of the media player library that it is using.
   * @event module:StreamPlayer~setVolume
   * @param newVolume {Number}
   */
  (0, _defineProperty2["default"])(this, "setVolume", function (newVolume) {
    _this.volume = newVolume;
    _this._invokePlayerMethod(_playerMethods["default"].setVolume, newVolume);
  });
  /**
   * Get the volume
   * @returns {Number}
   */
  (0, _defineProperty2["default"])(this, "getVolume", function () {
    return _this.volume;
  });
  /**
   * @returns {{ elapsedPercent: Number, elapsedSeconds: Number, duration: Number }}
   */
  (0, _defineProperty2["default"])(this, "getTimes", function () {
    return _this._invokePlayerMethod(_playerMethods["default"].getTimes);
  });
  /**
   * Method responsible for clearing the tunerChannel of registered event handlers,
   * and calling clearMedia on the currently loaded player.
   * @function clearMedia
   */
  (0, _defineProperty2["default"])(this, "clearMedia", function () {
    _this.clearTunerChannel();
    _this._invokePlayerMethod(_playerMethods["default"].unload);
  });
  /**
   * Scrub player to specified position
   * @event module:StreamPlayer~seek
   * @param position {Number}
   */
  (0, _defineProperty2["default"])(this, "seek", function (position) {
    _this._invokePlayerMethod(_playerMethods["default"].seek, position);
  });
  /**
   * Method used to clear the current timer that is monitoring a stream playback attempt
   * in ._monitorForStreamTimeout.
   */
  (0, _defineProperty2["default"])(this, "clearTimeout", function () {
    _this.timer.clear();
  });
  /**
   * Get the current stream ID
   * @returns {String} The stream ID
   */
  (0, _defineProperty2["default"])(this, "getCurrentStreamId", function () {
    return _this.stream.id;
  });
  /**
   * Get the current stream
   * @returns {Object} The stream
   */
  (0, _defineProperty2["default"])(this, "getCurrentStream", function () {
    return _this.stream;
  });
  /**
   * Get the StreamPlayer configuration.
   * @returns {Object} The configuaration object used for the current player
   */
  (0, _defineProperty2["default"])(this, "getPlayerConfig", function () {
    return _this.configuration;
  });
  (0, _defineProperty2["default"])(this, "requestInstreamAds", function () {
    _this._invokePlayerMethod(_playerMethods["default"].requestInstreamAds);
  });
  /**
   * Utility method to clear the tunerChannel of all streamEvents handlers.
   * @function clearTunerChannel
   */
  (0, _defineProperty2["default"])(this, "clearTunerChannel", function () {
    (0, _forEach["default"])(_streamEvents["default"], function (event) {
      return _this.removeAllListeners(event);
    });
  });
  /**
   * Set all the player listeners
   * @function setPlayerListeners
   */
  (0, _defineProperty2["default"])(this, "setPlayerListeners", function () {
    _this._toggleEventListeners(_playerMethods["default"].on);
  });
  /**
   * Clear all registered player listeners
   * @function clearPlayerListeners
   */
  (0, _defineProperty2["default"])(this, "clearPlayerListeners", function () {
    _this._toggleEventListeners(_playerMethods["default"].off);
  });
  (0, _defineProperty2["default"])(this, "_toggleEventListeners", function (onOrOff) {
    if (_this.stream.useStreamMetadata) {
      _this._invokePlayerMethod(onOrOff, _hlsEvents["default"].FRAG_PARSING_METADATA, _this._onMetadata);
    }
    _this._invokePlayerMethod(onOrOff, _htmlMediaEvents["default"].seeked, _this._onSeeked);
    _this._invokePlayerMethod(onOrOff, _htmlMediaEvents["default"].progress, _this._onProgress);
    _this._invokePlayerMethod(onOrOff, _htmlMediaEvents["default"].playing, _this._onPlay);
    _this._invokePlayerMethod(onOrOff, _htmlMediaEvents["default"].play, _this._onPlay);
    _this._invokePlayerMethod(onOrOff, _htmlMediaEvents["default"].waiting, _this._onWaiting);
    _this._invokePlayerMethod(onOrOff, _htmlMediaEvents["default"].timeupdate, _this._onTimeUpdate);
    _this._invokePlayerMethod(onOrOff, _htmlMediaEvents["default"].ended, _this._onEnded);
    _this._invokePlayerMethod(onOrOff, _htmlMediaEvents["default"].error, _this._onError);
  });
  (0, _defineProperty2["default"])(this, "_onMetadata", /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_, data) {
      var meta;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(data && data.frag && data.frag.relurl)) {
              _context2.next = 5;
              break;
            }
            _context2.next = 3;
            return mm.fetchFromUrl(data.frag.relurl);
          case 3:
            meta = _context2.sent;
            _this.eventEmitter.emit(_streamEvents["default"].meta, meta);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }());
  (0, _defineProperty2["default"])(this, "_onSeeked", function (event) {
    _this.eventEmitter.emit(_streamEvents["default"].seeked, event);
  });
  (0, _defineProperty2["default"])(this, "_onPlay", function (event) {
    // Occasionally, a player may emit a waiting event and immediately recover and emit a playing
    // event faster than we can enter the waiting state and register a listener for the play event
    // emitted below. Setting a timeout here buys us time to enter the waiting state and register
    // listeners before below we emit the play event.
    setTimeout(function () {
      _this.eventEmitter.emit(_streamEvents["default"].play, event);
    });
  });
  (0, _defineProperty2["default"])(this, "_onProgress", function (event) {
    _this.eventEmitter.emit(_streamEvents["default"].buffer, event);
  });
  (0, _defineProperty2["default"])(this, "_onTimeUpdate", function () {
    _this.eventEmitter.emit(_streamEvents["default"].positionChanged, _this.getTimes());
  });
  (0, _defineProperty2["default"])(this, "_onWaiting", function (event) {
    _this.eventEmitter.emit(_streamEvents["default"].waiting, event);
  });
  (0, _defineProperty2["default"])(this, "_onEnded", function () {
    _this.eventEmitter.emit(_streamEvents["default"].mediaEnded, _this.stream);
  });
  (0, _defineProperty2["default"])(this, "_onError", function () {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var _this$configuration = _this.configuration,
      isWebMediaPlayerEnabled = _this$configuration.isWebMediaPlayerEnabled,
      abTestIds = _this$configuration.abTestIds;

    // allow unfiltered logging for Web Media Player variant and control groups
    if (typeof isWebMediaPlayerEnabled !== 'boolean' && (0, _get["default"])(error, 'errorData.isNetworkError')) {
      return;
    }
    var _this$stream = _this.stream,
      streamId = _this$stream.id,
      url = _this$stream.url,
      format = _this$stream.format;

    // just in case error/message are large, plain objects or contain self-references.
    // eventKeys will help us debug and code against potential edge cases.
    var errorData = error instanceof Error ? {
      error: error.errorData || error
    } : {
      eventKeys: {
        error: Object.keys(error),
        message: message
      }
    };
    var eventMessage = typeof message === 'string' && message.length ? message : 'player error: during playback';
    _this.eventEmitter.emit(_streamEvents["default"].error, {
      message: eventMessage,
      context: _objectSpread(_objectSpread({}, errorData), {}, {
        playerName: _this.player.name,
        streamId: streamId,
        url: url,
        format: format,
        isWebMediaPlayerEnabled: isWebMediaPlayerEnabled,
        abTestIds: abTestIds
      })
    });
  });
  /**
   * @param stream {object}
   * @param options {{
   *    url: String,
   *    format: String,
   *    additionalTimeout: Number,
   *    playbackPosition: Number
   *  }}
   * @returns {Promise}
   * @private
   */
  (0, _defineProperty2["default"])(this, "_attemptStreamPlayback", /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(stream, options) {
      var players;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this.playerLoader.getPlayers(stream);
          case 2:
            players = _context3.sent;
            _this.stream = stream;
            _this.clearPlayerListeners();
            _debugger["default"].log('attempting playback with players: ', players);
            _context3.next = 8;
            return _this._attemptPlaybackWithPlayers(players, options);
          case 8:
            _this.setPlayerListeners();
            _this.setVolume(_this.volume);
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }());
  /**
   * Method to attempt to load and play each media player in the "player" argument array.
   *
   * @param players {Array} An array of media players
   * @param options {{
   *    url: String,
   *    format: String,
   *    additionalTimeout: Number,
   *    playbackPosition: Number
   *  }}
   * @returns {Promise}
   * @private
   */
  (0, _defineProperty2["default"])(this, "_attemptPlaybackWithPlayers", /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(players, options) {
      var url, format, playbackPosition, additionalTimeout, instreamTrackingUrl, selectedPlayer;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this._invokePlayerMethod(_playerMethods["default"].destroy);
          case 2:
            url = options.url, format = options.format, playbackPosition = options.playbackPosition, additionalTimeout = options.additionalTimeout, instreamTrackingUrl = options.instreamTrackingUrl;
            selectedPlayer = players.shift();
            if (selectedPlayer) {
              _context4.next = 6;
              break;
            }
            throw new Error('could not find a player to play stream');
          case 6:
            _context4.prev = 6;
            _context4.next = 9;
            return _this._monitorForStreamTimeout(_this._loadPlayerAndPlay(selectedPlayer, url, format, playbackPosition, instreamTrackingUrl), additionalTimeout);
          case 9:
            _context4.next = 17;
            break;
          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](6);
            _debugger["default"].log('error while attempting playback with player', {
              error: _context4.t0,
              player: selectedPlayer,
              url: url
            });
            _this._onError(_context4.t0, 'player error: attempting playback');
            _context4.next = 17;
            return _this._attemptPlaybackWithPlayers(players, options);
          case 17:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[6, 11]]);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }());
  /**
   * @param player {Player}
   * @param url {String}
   * @param format {String}
   * @param playbackPosition {Number}
   * @param instreamTrackingUrl {String|undefined}
   * @returns {Promise<void>}
   * @private
   */
  (0, _defineProperty2["default"])(this, "_loadPlayerAndPlay", /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(player, url, format, playbackPosition, instreamTrackingUrl) {
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _this.player = player;
            _this.eventEmitter.emit(_streamEvents["default"].playerSelected, player.name);
            _debugger["default"].log('attempting playback with new player', player);
            _context5.next = 5;
            return _this._invokePlayerMethod(_playerMethods["default"].load, url, format, playbackPosition, instreamTrackingUrl);
          case 5:
            _context5.next = 7;
            return _this._invokePlayerMethod(_playerMethods["default"].play, playbackPosition);
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x8, _x9, _x10, _x11, _x12) {
      return _ref5.apply(this, arguments);
    };
  }());
  /**
   * Utility method to handling aborting stream load/play requests that timeout.
   *
   * @param promiseToMonitor {Promise}
   * @param additionalTimeout {Number}
   * @returns {Promise}
   * @private
   */
  (0, _defineProperty2["default"])(this, "_monitorForStreamTimeout", /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(promiseToMonitor) {
      var additionalTimeout,
        _args6 = arguments;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            additionalTimeout = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 0;
            _context6.next = 3;
            return Promise.race([promiseToMonitor, _this._startTimeoutTimer(_this.streamTimeout + additionalTimeout)]);
          case 3:
            _this.timer.clear();
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x13) {
      return _ref6.apply(this, arguments);
    };
  }());
  (0, _defineProperty2["default"])(this, "_startTimeoutTimer", /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(timeout) {
      var timeoutError;
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return new Promise(function (resolve) {
              return _this.timer.start(resolve, timeout);
            });
          case 2:
            _this.timer.clear();
            timeoutError = new Error('stream timeout');
            timeoutError.errorData = {
              code: _errorCodes["default"].STREAM_TIMEOUT,
              isNetworkError: true
            };
            throw timeoutError;
          case 6:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x14) {
      return _ref7.apply(this, arguments);
    };
  }());
  /**
   * Utility method that safely executes the player "method" argument if there is a player
   * loaded and the specified method exists on it.
   *
   * @param method {String}
   * @param args {*}
   * @returns {*}
   * @private
   */
  (0, _defineProperty2["default"])(this, "_invokePlayerMethod", function (method) {
    var _this$player;
    if (!_this.player) {
      return null;
    }
    if (!_this.player[method]) {
      _debugger["default"].log("unknown player method (".concat(method, ")"), _this.player);
      return null;
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return (_this$player = _this.player)[method].apply(_this$player, args);
  });
  (0, _defineProperty2["default"])(this, "on", function (eventName, cb) {
    _this.eventEmitter.on(eventName, cb);
  });
  (0, _defineProperty2["default"])(this, "once", function (eventName, cb) {
    _this.eventEmitter.once(eventName, cb);
  });
  (0, _defineProperty2["default"])(this, "remove", function (eventName, cb) {
    _this.eventEmitter.off(eventName, cb);
  });
  (0, _defineProperty2["default"])(this, "removeAllListeners", function (eventName) {
    _this.eventEmitter.removeAllListeners(eventName);
  });
  this.player = null;
  this.stream = {};
  this.events = _streamEvents["default"];
  this.configuration = config || {};
  var volume = config.volume,
    _timeout = config.timeout,
    blankMp3Url = config.blankMp3Url;
  this.volume = volume || 1;
  this.streamTimeout = _timeout || 0;
  this.blankMp3Url = blankMp3Url || '';
  this.timer = new _Timer["default"]();
  this.eventEmitter = new _events["default"]();
  this.playerLoader = new _PlayerLoader["default"](config);
});
var _default = exports["default"] = StreamPlayer;
//# sourceMappingURL=StreamPlayer.js.map